import { GetPartnerMaterialDownloadQuerySchema, GetPartnerMaterialDownloadResponseSchema } from './get-partner-material-download.schema';
export const getPartnerMaterialDownloadContract = {
    method: 'GET',
    path: '/api/v2/partner/materials/:id/download',
    description: 'Get a short-lived download link for a partner file',
    requestSchema: GetPartnerMaterialDownloadQuerySchema,
    responseSchema: GetPartnerMaterialDownloadResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member',
            404: 'Material or file not found'
        }
    }
};

//# sourceMappingURL=get-partner-material-download.contract.js.map